export const environment = {
  production: false,
  name: 'dev',
  environmentName: 'dev',
  api: {
    baseUrl: 'https://genesis-api-dev.neointelligence.com.au/api/v1/genesis'
  },
  // Honeycomb (OpenTelemetry traces). Shared with Neo.One's Dev-tier key so
  // traces from both apps correlate in the same Honeycomb environment.
  honeycombApiKey: 'hcaik_01kyy0ysmdqea79d7t641yvtg47dkqvdrae99w037gxj5sdwz7a6vq2ewe',
  azureAdB2C: {
    authority: 'https://neointelligenceCustomerDir.b2clogin.com/neointelligenceCustomerDir.onmicrosoft.com/B2C_1_genesis',
    clientId: '7cf22c2c-26bc-433d-87ea-6db44454a301',
    redirectUri: 'https://genesis-portal-dev.neointelligence.com.au',
    postLogoutRedirectUri: 'https://genesis-portal-dev.neointelligence.com.au',
    knownAuthorities: ['neointelligenceCustomerDir.b2clogin.com'],
    scopes: ['https://neointelligenceCustomerDir.onmicrosoft.com/0ab93773-101e-41a8-83f5-d330b8d2b186/access_as_user']
  }
};